import {
  Alert,
  Box,
  Button,
  FormControl,
  Icon,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Paper,
  Link,
  Snackbar,
  Stack,
  Typography,
  CircularProgress,
  useTheme,
  TextField,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import background from "../../assets/headerHome.jpeg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import logoMw from "../../assets/logo4.png";
import logoMw2 from "../../assets/logo5.png";
import Code from "./textFieldCode";
import Interval from "./contador";

export default function RedefinirSenha() {
  const [rev, setRev] = useState(false);
  const [email, setEmail] = useState("");
  const [Null, setNull] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertServiceOpen, setAlertServiceOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [sended, setSended] = useState(false);
  const [user, setUser] = useState("");
  const [code, setCode] = useState("");
  const [codeAlert, setCodeAlert] = useState(false);
  const [id, setId] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  const intervalRef = useRef(null);
  const url = `${window?.config?.REACT_APP_BASE_URL || ""}`;
  const logo = `${window?.config?.REACT_APP_LOGO_SMALL_URL || logoMw}`;
  const logoDarkMode = `${
    window?.config?.REACT_APP_LOGO_SMALL_MODE_DARK_URL ||
    window?.config?.REACT_APP_LOGO_SMALL_URL ||
    logoMw2
  }`;
  const isPartner = window?.config?.REACT_APP_IS_PARTNER === "true" || false;
  const backgroundImage = `${
    window?.config?.REACT_APP_BACKGROUND_IMAGE_URL || background
  }`;

  const navigate = useNavigate();

  const theme = useTheme();
  const colorMode = theme.palette.mode;

  const styles = {
    LoadingLogo: {
      position: "relative",
      margin: "50px",
    },
    CircularProgress: {
      color: "primary",
      position: "absolute",
      top: -9,
      left: -6,
      zIndex: 1,
    },
    ContainerBox: {
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    paperPhoto: {
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: "cover",
      backgroundAttachment: "fixed",
      backgroundRepeat: "no-repeat",
      borderRadius: "0px!important",
      width: "65vw",
      height: "100vh",
      minWidth: "300px",
      minHeight: "500px",
      display: { xs: "none", lg: "flex" },
      justifyContent: "center",
      alignContent: "center",
      objectFit: "cover",
    },
    boxTitlePhoto: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignContent: "center",
      justifyContent: " center",
      alignItems: "center",
      flexDirection: "column",
      color: "white",
      padding: "15px",
    },
    title: {
      fontSize: { lg: "3em", md: "2em" },
      fontFamily: "Rubik",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "1em",
      width: "60%",
      maxWidth: "max-content",
      textWrap: "wrap",
    },
    subTitle: { fontSize: "1.25em", width: "60%", fontWeight: "300" },
    boxHeaderAndForm: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "start",
      alignItems: "center",
      height: "100%",
      gap: 6,
      padding: 4,
      minWidth: "330px",
      width: { xs: "100vw", lg: "35vw" },
    },
    boxHeader: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      minWidth: "300px",
      padding: 2,
      gap: "auto",
    },
    icon: { height: "auto", width: "auto" },
    img: { height: "auto", width: "100px" },
    stackForm: {
      width: "100%",
      maxWidth: "450px",
      height: "100vh",
      minHeight: "50vh",
      maxHeight: "600px",
      flexDirection: "column",
      display: "flex",
      alignItems: "center",
      position: "relative",
    },
    boxForm: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      flex: 1,
      width: { xs: "80vw", md: "100%" },
      maxWidth: "520px",
    },
    boxFormCode: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      flex: 1,
      gap: 2,
      width: { xs: "80%", md: "100%" },
      minWidth: "300px",
    },
    boxTitles: { gap: 2, display: "flex", flexDirection: "column" },
    boxFieldAndButton: {
      display: "flex",
      padding: "12px 0px",
      flexDirection: "column",
      alignItems: "center",
      gap: 3,
      alignSelf: "stretch",
    },
    textField: {
      width: "100%",
      marginTop: 2,
    },
    button: {
      width: "100%",
      borderRadius: "5px",
      marginTop: "25px",
      height: "40px",
      marginBottom: "20px",
      fontSize: 16,
      textTransform: "none",
    },
    titleForm: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "5px",
      alignSelf: "stretch",
    },
    formCodeContent: {
      display: "flex",
      padding: "12px 0px",
      flexDirection: "column",
      alignItems: "center",
      gap: 4,
      alignSelf: "stretch",
      width: "100%",
    },
    codeErrorMsg: {
      fontSize: "13px",
      marginTop: "-10px",
      color: "#e83750",
      marginBottom: "-20px",
    },
  };

  useEffect(() => {
    if (email.includes("@") && email.includes(".")) setEmailValid(true);
    else setEmailValid(false);
  }, [email]);

  const handleNextUpdatePassword = async () => {
    try {
      const response = await axios.post(
        `${url}/usuario/resetPassword/validate`,
        {
          code,
          usuarioId: id,
        }
      );

      navigate(`/resetPassword/${response.data.token}/${id}`);
    } catch (error) {
      if (error?.response?.status == 401) {
        setCodeAlert(true);
      } else {
        setAlertServiceOpen(true);
      }
    }
  };

  const handleSend = async () => {
    if (!email || !emailValid) {
      setNull(true);
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${url}/usuario/resetPassword/request`,
        {
          email: email.toLowerCase(),
        }
      );
      setUser(response.data.login);
      setId(response.data.usuarioId);
      setSended(true);
      console.log(response.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.status == 404) {
        setAlertOpen(true);
      } else {
        setAlertServiceOpen(true);
      }
    }
    setLoading(false);
  };
  // function handleStartCounter() {
  //  if (intervalRef.current) {
  //   intervalRef.current.startCounter();
  //}
  // }

  return (
    <>
      <Box sx={styles.ContainerBox}>
        <Paper sx={styles.boxHeaderAndForm}>
          <Box sx={styles.boxHeader}>
            <Button
              variant="text"
              sx={{ textTransform: "none" }}
              color="primary.main"
              disabled={loading}
              href="/login"
              startIcon={<ArrowBackIcon />}
            >
              Voltar
            </Button>

            <Icon style={styles.icon}>
              <img
                alt=""
                src={colorMode === "light" ? logo : logoDarkMode}
                style={styles.img}
              />
            </Icon>
          </Box>

          <Stack sx={styles.stackForm}>
            {loading && (
              <Box sx={styles.boxFormCode}>
                <Box sx={styles.LoadingLogo}>
                  <Icon style={{ width: 80, height: 80 }}>
                    <img
                      src={logo}
                      style={{ width: 80, height: 80 }}
                      alt="mw icon"
                    />
                  </Icon>

                  <CircularProgress
                    size={100}
                    sx={styles.CircularProgress}
                    thickness={2.5}
                  />
                </Box>
              </Box>
            )}
            {!loading && !sended && (
              <Box sx={styles.boxForm}>
                <Box sx={styles.boxTitles}>
                  <Typography
                    fontSize="2em"
                    fontWeight={400}
                    color="text.primary"
                  >
                    Esqueceu a senha?
                  </Typography>
                  <Typography
                    fontSize="0.875em"
                    fontWeight={400}
                    color="text.secondary"
                  >
                    Digite o endereço de e-mail verificado da sua conta de
                    usuário e lhe enviaremos um link de redefinição de senha.
                  </Typography>
                </Box>
                <Box sx={styles.boxFieldAndButton}></Box>
                <TextField
                  error={Null && !emailValid}
                  value={email}
                  type="text"
                  onChange={(event) => {
                    setEmail(event.target.value);
                  }}
                  placeholder="Email"
                  helperText={Null && !emailValid && "Email inválido"}
                  sx={styles.textField}
                />

                <Button
                  variant="contained"
                  onClick={() => {
                    handleSend();
                  }}
                  sx={styles.button}
                >
                  Enviar
                </Button>
              </Box>
            )}
            {!loading && sended && (
              <Box sx={styles.boxFormCode}>
                <Box sx={styles.titleForm}>
                  <Typography
                    sx={{ fontSize: { xs: 20, sm: 30 } }}
                    color="text.primary"
                    fontWeight={500}
                  >
                    Redefinição de Senha
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    fontWeight={400}
                    color="text.secondary"
                  >
                    Enviamos um código para {email.toLowerCase()}
                  </Typography>
                </Box>
                <Box sx={styles.formCodeContent}>
                  <Code onChange={(value) => setCode(value.join(" "))} />
                  {codeAlert && (
                    <Typography sx={styles.codeErrorMsg}>
                      O código não está correto
                    </Typography>
                  )}

                  <Button
                    variant="contained"
                    onClick={handleNextUpdatePassword}
                    sx={styles.button}
                  >
                    Verificar
                  </Button>

                  <Interval
                    onTimeout={(value) => setRev(true)}
                    ref={intervalRef}
                  />
                  {rev && (
                    <Link
                      onClick={() => {
                        handleSend();
                        // handleStartCounter();
                        setRev(false);
                      }}
                      href="#"
                      sx={{
                        width: "100%",
                        textDecoration: "none!important",
                        marginBottom: "20px",
                        textAlign: "center",
                      }}
                    >
                      Reenviar email de redefinição
                    </Link>
                  )}
                </Box>
              </Box>
            )}
          </Stack>
        </Paper>
        <Paper sx={styles.paperPhoto}>
          {!isPartner && (
            <Box sx={styles.boxTitlePhoto}>
              <Typography sx={styles.title}>
                Monitoramento eficiente e confiável.
              </Typography>
              <br></br>
              <Typography sx={styles.subTitle}>
                Monitoramento de infraestrutura de redes para provedores de
                internet, com suporte confiável e atencioso.
              </Typography>
            </Box>
          )}
        </Paper>
      </Box>

      <Snackbar
        autoHideDuration={6000}
        open={alertOpen}
        onClose={() => {
          setAlertOpen(false);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="warning">Alerta: Esse email não está cadastrado</Alert>
      </Snackbar>

      <Snackbar
        autoHideDuration={6000}
        open={alertServiceOpen}
        onClose={() => {
          setAlertServiceOpen(false);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="error">
          Erro: Não foi possível se conectar ao Servidor
        </Alert>
      </Snackbar>
    </>
  );
}
